import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const highlights = [
  {
    title: "Multi-Vendor Marketplace",
    description: "Single store or marketplace with vendor onboarding, commissions, and payouts.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Secure Payments",
    description: "UPI, cards, wallets, and COD with PCI-compliant gateway integration.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="6" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M3 10h18" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Order Tracking",
    description: "Real-time shipment updates with notifications across web and mobile.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Vendor Self-Service",
    description: "Sellers manage products, inventory, orders, and earnings independently.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3 9l2-5h14l2 5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M4 9v10h16V9" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];

const EcaIntroSection: React.FC = () => (
  <section className="wdev-intro" aria-labelledby="eca-intro-title">
    <div className="container">
      <div className="wdev-intro__grid">
        <AnimatedSection className="wdev-intro__content">
          <span className="wdev-label wdev-label--purple">E-Commerce Platform</span>
          <h2 id="eca-intro-title" className="wdev-intro__title">
            E-Commerce App Development Company
          </h2>

          <p className="wdev-intro__text">
            Whether you are launching a D2C brand, building a multi-vendor marketplace, or digitising
            a retail chain — our e-commerce app connects customers, vendors, and administrators in one
            scalable platform built for growth.
          </p>
          <p className="wdev-intro__text">
            WebTech develops custom e-commerce apps in Bangalore with secure checkout, inventory
            management, vendor panels, analytics dashboards, and native mobile apps for iOS and
            Android — similar to Amazon, Flipkart, and Shopify-powered marketplaces.
          </p>

          <div className="wdev-intro__highlights">
            {highlights.map((item) => (
              <div className="wdev-intro__highlight" key={item.title}>
                <div className="wdev-intro__highlight-icon">{item.icon}</div>
                <div>
                  <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                  <p className="wdev-intro__highlight-desc">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </AnimatedSection>

        <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
          <EstimateProjectForm />
        </AnimatedSection>
      </div>
    </div>
  </section>
);

export default EcaIntroSection;
